import MUICollapse, { CollapseProps } from '@mui/material/Collapse';

interface ICollapsePros extends CollapseProps {}

const Collapse = (props: ICollapsePros) => {
  return <MUICollapse data-testid="of-Collapse" {...props}></MUICollapse>;
};

export default Collapse;
